function scrollTo(id, scrollBehavior = undefined) {
	if (!id) {
		return false;
	}

	const targetElement = document.getElementById(id);
	if (targetElement) {
		targetElement.scrollIntoView({alignToTop: true, inline: 'nearest', block: 'start', behavior: scrollBehavior});
		return true;
	}

	return false;
}

function isOnPageLink(linkElement) {
	return location.pathname.replace(/^\//, '') === linkElement.pathname.replace(/^\//, '') &&
		location.hostname === linkElement.hostname;
}

[...document.querySelectorAll('a[href*="#"]:not([href="#"])')].forEach(linkElement => {
	linkElement.addEventListener('click', e => {
		if (isOnPageLink(linkElement) && scrollTo(linkElement.hash.slice(1), 'smooth')) {
			e.preventDefault();

			if (window.history) {
				window.history.pushState(null, document.title, linkElement.href);
			}
		}
	});
});

if (location.hash.length > 1) {
	scrollTo(location.hash.slice(1));
} else {
	window.scroll({top: 0, left: 0});
}
